<template>
  <div>
    <div class="item_page_header">
      <div class="header_route" v-if="!showNav && showBackBtn">
        <span class="route_back" @click="routeBack"></span>
      </div>
      <p class="item_page_title">{{header_title}}</p>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      "title": {
        type: String,
        default: ""
      },
      "publish": {
        type: Boolean,
        default: false
      },
      "nav": {
        type: Boolean,
        default: false
      },
      "showBackBtn": {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        header_title: "",
        showPublish: true,
        showNav: false,
        transitionNav: false
      }
    },
    mounted() {
      this.header_title = this.title;
      this.showPublish = this.publish;
      this.showNav = this.nav;
    },
    methods: {
      routeBack() {
        this.$router.go(-1);
      },

      stretchNav() {
        this.transitionNav = !this.transitionNav;
      }
    }
  }
</script>
<style scoped>
  .item_page_header {
    width: 100%;
    padding: 10px 0px;
    /* height: 60px; */
    /* line-height: 60px; */
    /* background: rgba(237, 237, 237, 0.9); */
    position: relative;
  }

  .header_route {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100px;
    display: flex;
    z-index: 1;
    align-items: center;
  }

  .route_back {
    width: 35px;
    height: 35px;
    background: url('../../../assets/images/arrow_down.png') no-repeat;
    background-size: 100% auto;
    cursor: pointer;
    transform: rotateZ(90deg);
  }

  .item_page_title {
    font-size: 18px;
    color: #333;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: normal;
  }
</style>